import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredRgf = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#clip0_8287_8539)">
      <path
        d="M14.5874 9.02246C14.4121 8.96044 14.3886 9.00971 14.3518 9.15619C14.1459 9.97438 13.7608 10.7002 13.1792 11.32C13.1339 11.3679 13.0886 11.4172 13.0367 11.4577C12.8801 11.5808 12.6871 11.5751 12.5549 11.4476C12.4192 11.3169 12.4094 11.1066 12.546 10.9531C12.7222 10.7561 12.9085 10.5669 13.0487 10.3417C13.3371 9.87804 13.5487 9.39417 13.6628 8.84783C13.9667 7.39532 13.5589 6.17244 12.5691 5.10351C12.4094 4.93064 12.4036 4.71597 12.5483 4.57301C12.7022 4.42125 12.9156 4.43093 13.0957 4.61216C13.7209 5.24164 14.1362 5.99077 14.3518 6.84547C14.3944 7.01526 14.4396 7.04253 14.6131 6.98579C15.3074 6.75837 15.9991 7.26996 15.9991 7.99489C16.0302 8.75325 15.2986 9.27496 14.5874 9.02246Z"
        fill="url(#paint0_linear_8287_8539)"
      />
      <path
        d="M3.42386 10.8789C3.5929 11.0469 3.60798 11.3179 3.46911 11.4472C3.33823 11.5691 3.11063 11.5444 2.93361 11.3786C2.42383 10.9009 2.07688 10.3207 1.84928 9.66698C1.79161 9.50158 1.71973 9.33839 1.68513 9.16815C1.65185 9.00539 1.58131 8.98296 1.438 9.03222C1.14296 9.13472 0.856797 9.09161 0.580836 8.95612C0.141161 8.7397 -0.0868848 8.25275 0.0311309 7.78075C0.15802 7.27224 0.579948 6.92781 1.07198 6.93045C1.21351 6.93221 1.35104 6.9564 1.48015 7.01446C1.59905 7.06769 1.65584 7.02898 1.68335 6.90757C1.87324 6.07838 2.28053 5.36049 2.83201 4.71782C2.87016 4.67339 2.90876 4.62852 2.9518 4.58893C3.12394 4.43189 3.33823 4.42353 3.48775 4.56517C3.63549 4.70506 3.62883 4.94744 3.46823 5.11635C3.11241 5.4907 2.80894 5.89759 2.60884 6.37839C2.36704 6.96036 2.22285 7.56652 2.25834 8.18984C2.29827 8.8787 2.50103 9.53501 2.84887 10.1412C3.00548 10.4143 3.20025 10.6563 3.42386 10.8789Z"
        fill="url(#paint1_linear_8287_8539)"
      />
      <path
        d="M11.6304 3.1637C11.6277 3.31018 11.5873 3.43643 11.4347 3.50285C11.2515 3.58247 11.1037 3.52001 10.9729 3.39464C10.6734 3.10827 10.3397 2.87161 9.96928 2.68202C9.36633 2.37366 8.72878 2.2197 8.02734 2.22938C7.35652 2.2175 6.70965 2.40709 6.09872 2.71149C5.74023 2.88965 5.41502 3.12543 5.12487 3.40608C4.95893 3.56663 4.73311 3.56663 4.59246 3.42191C4.44916 3.27367 4.46957 3.04009 4.6497 2.87953C5.12575 2.45504 5.62754 2.0741 6.24956 1.86911C6.4714 1.79565 6.68214 1.68392 6.91462 1.64125C7.05837 1.61486 7.08055 1.56339 7.03663 1.41911C6.9093 1.00429 6.9794 0.618513 7.30372 0.308393C7.63248 -0.00612587 8.02512 -0.0707892 8.45193 0.0730537C8.95771 0.24373 9.28026 0.840656 9.1059 1.35444C9.02249 1.60122 9.13474 1.63817 9.31176 1.6782C10.1538 1.86867 10.8655 2.29008 11.4835 2.87953C11.5665 2.95871 11.6321 3.04537 11.6304 3.1637Z"
        fill="url(#paint2_linear_8287_8539)"
      />
      <path
        d="M10.4169 3.8728C10.4134 4.01488 10.3379 4.11122 10.278 4.20975C9.94218 4.76577 9.59967 5.31783 9.26071 5.87208C8.98741 6.31901 8.71411 6.76593 8.44392 7.21462C8.21365 7.59688 7.93104 7.60392 7.69545 7.21946C7.06145 6.18528 6.43321 5.14803 5.80409 4.11122C5.67632 3.90051 5.72911 3.67617 5.92699 3.56136C6.08094 3.47206 6.28103 3.52881 6.39728 3.72236C6.81832 4.42354 7.87824 6.16945 7.99404 6.33616C8.07079 6.44658 8.11028 6.36608 8.14976 6.30053C8.44303 5.81622 8.73585 5.3319 9.02956 4.84803C9.26559 4.46005 9.49718 4.06899 9.74298 3.68717C9.83703 3.54068 10.0061 3.50461 10.1671 3.542C10.3388 3.58159 10.4054 3.72324 10.4169 3.8728Z"
        fill="url(#paint3_linear_8287_8539)"
      />
      <path
        d="M3.91941 5.69214C4.06271 5.69566 4.15988 5.77044 4.25926 5.82982C4.82006 6.16282 5.37686 6.50241 5.93588 6.83848C6.38665 7.10945 6.83741 7.38042 7.28996 7.64832C7.6755 7.87662 7.6826 8.15682 7.29484 8.3904C6.25177 9.019 5.2056 9.64188 4.15988 10.2656C3.94736 10.3923 3.72109 10.34 3.60529 10.1438C3.51523 9.99115 3.57246 9.79276 3.76768 9.67751C4.47488 9.26006 6.2358 8.20917 6.40395 8.09436C6.51531 8.01826 6.43412 7.97911 6.36801 7.93996C5.87953 7.6492 5.39106 7.35887 4.90302 7.06766C4.51171 6.83364 4.11729 6.60402 3.73218 6.36033C3.58444 6.26707 3.54806 6.09947 3.58577 5.9398C3.6257 5.76956 3.76856 5.70358 3.91941 5.69214Z"
        fill="url(#paint4_linear_8287_8539)"
      />
      <path
        d="M12.1139 10.3373C11.9706 10.3338 11.8735 10.259 11.7741 10.1996C11.2133 9.86665 10.6565 9.52706 10.0975 9.19098C9.64669 8.92001 9.19592 8.64904 8.74338 8.38115C8.35783 8.15285 8.35073 7.87264 8.7385 7.63906C9.78156 7.01047 10.8277 6.38759 11.8735 5.76383C12.086 5.63714 12.3122 5.68949 12.428 5.88568C12.5181 6.03832 12.4609 6.2367 12.2657 6.35196C11.5585 6.76941 9.79753 7.8203 9.62938 7.93511C9.51802 8.01121 9.59921 8.05036 9.66532 8.08951C10.1538 8.38027 10.6423 8.6706 11.1303 8.9618C11.5216 9.19582 11.916 9.42544 12.3012 9.66914C12.4489 9.7624 12.4853 9.92999 12.4476 10.0897C12.4076 10.2599 12.2648 10.3259 12.1139 10.3373Z"
        fill="url(#paint5_linear_8287_8539)"
      />
      <path
        d="M5.71436 12.1361C5.7179 11.994 5.79333 11.8976 5.85322 11.7991C6.18908 11.2431 6.53159 10.691 6.87055 10.1368C7.14385 9.68984 7.41715 9.24291 7.68735 8.79423C7.91761 8.41197 8.20023 8.40493 8.43582 8.78939C9.06982 9.82357 9.69805 10.8608 10.3272 11.8976C10.4549 12.1083 10.4022 12.3327 10.2043 12.4475C10.0503 12.5368 9.85023 12.48 9.73399 12.2865C9.31295 11.5853 8.25302 9.8394 8.13723 9.67268C8.06047 9.56227 8.02099 9.64277 7.9815 9.70831C7.68823 10.1926 7.39541 10.6769 7.10171 11.1608C6.86567 11.5488 6.63408 11.9399 6.38829 12.3217C6.29423 12.4682 6.12519 12.5042 5.96414 12.4668C5.79244 12.4273 5.72589 12.2856 5.71436 12.1361Z"
        fill="url(#paint6_linear_8287_8539)"
      />
      <path
        d="M4.48954 12.8368C4.4922 12.6903 4.53257 12.564 4.68519 12.4976C4.86843 12.418 5.01617 12.4805 5.14705 12.6058C5.44653 12.8922 5.78017 13.1288 6.15063 13.3184C6.75358 13.6268 7.39113 13.7808 8.09256 13.7711C8.76339 13.783 9.41026 13.5934 10.0212 13.289C10.3797 13.1108 10.7049 12.875 10.995 12.5944C11.161 12.4338 11.3868 12.4338 11.5274 12.5785C11.6707 12.7268 11.6503 12.9604 11.4702 13.1209C10.9942 13.5454 10.4808 13.8907 9.87034 14.1313C9.65295 14.2171 9.43289 14.2879 9.20528 14.3592C9.06597 14.4028 9.03935 14.4371 9.08328 14.5813C9.21061 14.9962 9.14051 15.3819 8.81619 15.6921C8.48743 16.0066 8.09478 16.0712 7.66797 15.9274C7.16219 15.7567 6.83965 15.1598 7.01401 14.646C7.09742 14.3992 6.98517 14.3623 6.80815 14.3223C5.96606 14.1318 5.25442 13.7104 4.63639 13.1209C4.55343 13.0417 4.48776 12.9551 4.48954 12.8368Z"
        fill="url(#paint7_linear_8287_8539)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_8287_8539"
        x1={14.2222}
        y1={11.2105}
        x2={14.2222}
        y2={4.77184}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC3366" />
        <stop offset={0.41} stopColor="#BD254E" />
        <stop offset={0.94} stopColor="#AE1733" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8287_8539"
        x1={1.79693}
        y1={11.1441}
        x2={1.79693}
        y2={4.85286}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE913" />
        <stop offset={0.79} stopColor="#FBA812" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8287_8539"
        x1={4.49796}
        y1={1.76926}
        x2={11.6304}
        y2={1.76926}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BBD631" />
        <stop offset={0.79} stopColor="#679C39" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8287_8539"
        x1={5.73444}
        y1={5.51226}
        x2={10.4169}
        y2={5.51226}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.41} stopColor="#BBD631" />
        <stop offset={0.77} stopColor="#679C39" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8287_8539"
        x1={5.5734}
        y1={10.0695}
        x2={5.5734}
        y2={6.08496}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE913" />
        <stop offset={0.79} stopColor="#FBA812" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_8287_8539"
        x1={9.5127}
        y1={8.01649}
        x2={13.5314}
        y2={8.01649}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC0068" />
        <stop offset={0.94} stopColor="#AE1733" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_8287_8539"
        x1={5.71436}
        y1={10.4962}
        x2={10.3968}
        y2={10.4962}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.32} stopColor="#1D2C6B" />
        <stop offset={0.37} stopColor="#1C3D78" />
        <stop offset={0.62} stopColor="#1895BD" />
        <stop offset={0.74} stopColor="#17B9D9" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_8287_8539"
        x1={4.48954}
        y1={14.2308}
        x2={11.6219}
        y2={14.2308}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.05} stopColor="#1D2C6B" />
        <stop offset={0.12} stopColor="#1B4982" />
        <stop offset={0.23} stopColor="#1A71A1" />
        <stop offset={0.34} stopColor="#1890B9" />
        <stop offset={0.44} stopColor="#17A7CA" />
        <stop offset={0.54} stopColor="#17B4D5" />
        <stop offset={0.63} stopColor="#17B9D9" />
      </linearGradient>
      <clipPath id="clip0_8287_8539">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredRgf)
const IconSvgColouredRgf = createIcon(ForwardRef, 'SvgColouredRgf')
export default IconSvgColouredRgf
